export const ACCESS_TOKEN = 'Access-Token'
export const USER_NAME = 'Login_Username'
export const USER_INFO = 'Login_Userinfo'
export const Cache = {
    set(key, value, ttl) {
        const data = {
            value,
            expiry: ttl ? Date.now() + ttl : null
        };
        localStorage.setItem(key, JSON.stringify(data));
    },
    get(key) {
        const data = localStorage.getItem(key);
        if (!data) return null;
        const { value, expiry } = JSON.parse(data);
        if (expiry && Date.now() > expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return value;
    },
    clearAll(){
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(USER_NAME);
        localStorage.removeItem(USER_INFO);
    }
};
 
